import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { StampExemptionReason } from 'shell/models/stamp-exemption-reason';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface RegisterTypeProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const CodeAnprListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: RegisterTypeProps): React.ReactElement => {
  const [anprCodes] = useHttpFetch<HttpResponseList<StampExemptionReason>, Array<ItemVM>>(
    `${__CERTIFICATION_API_URL__}/anpr/motivo-esenzione-bollo`,
    {
      onBootstrap: true,
      initialData: [],
      options: {
        method: 'GET',
        abortable: true,
        errorCatching: false,
        loading: false,
      },
      transformer: (response) => {
        return response.data?.payload?.list.map((item) => ({
          id: item.key.codice,
          value: item.descrizione,
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="code-anpr-label">
        Codice esenzione ANPR
      </InputLabel>
      <PmiSelect
        labelId="code-anpr-label"
        id="code-anpr"
        name="code-anpr"
        value={value}
        label="Codice esenzione ANPR"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(anprCodes.data as Array<ItemVM>)?.map((code: ItemVM) => (
          <MenuItem key={`${code.id}-code-anpr`} value={code.id}>
            {code.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CodeAnprListComponent.displayName = 'List code anpr component';

const CodeAnprList = memo(CodeAnprListComponent);

export default CodeAnprList as typeof CodeAnprListComponent;
